import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
import jsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";

self.MonacoEnvironment = {
  getWorker(_, label) {
    if (label === "json") {
      return new jsonWorker();
    }
    return new editorWorker();
  },
};

import "monaco-editor/esm/vs/basic-languages/dockerfile/dockerfile.contribution.js";
import "monaco-editor/esm/vs/basic-languages/markdown/markdown.contribution.js";
import "monaco-editor/esm/vs/basic-languages/perl/perl.contribution.js";
import "monaco-editor/esm/vs/basic-languages/python/python.contribution.js";
import "monaco-editor/esm/vs/basic-languages/r/r.contribution.js";
import "monaco-editor/esm/vs/basic-languages/shell/shell.contribution.js";
import "monaco-editor/esm/vs/basic-languages/yaml/yaml.contribution.js";
import "monaco-editor/esm/vs/editor/browser/coreCommands.js";
import "monaco-editor/esm/vs/editor/browser/widget/codeEditorWidget.js";
import "monaco-editor/esm/vs/editor/contrib/anchorSelect/browser/anchorSelect.js";
import "monaco-editor/esm/vs/language/json/monaco.contribution.js";

// The following is for find/replace buttons in the editor
import "monaco-editor/esm/vs/editor/contrib/find/browser/findController.js";
import "monaco-editor/esm/vs/editor/contrib/find/browser/findWidget.js";

// The following is for comment/uncomment functionality
import "monaco-editor/esm/vs/editor/contrib/comment/browser/comment.js";

// The following is for command palette (Cmd+Shift+P or fn+F1)
import "monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneCommandsQuickAccess.js";
import "monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneHelpQuickAccess.js";

// Multi-cursor: Cmd+D (add selection to next match), Cmd+Shift+L (select all occurrences), Alt+Click
import "monaco-editor/esm/vs/editor/contrib/multicursor/browser/multicursor.js";

// Line operations: Alt+Up/Down (move line), Alt+Shift+Up/Down (copy line), Cmd+Shift+K (delete line)
import "monaco-editor/esm/vs/editor/contrib/linesOperations/browser/linesOperations.js";

// Bracket matching: Cmd+Shift+\ (jump to matching bracket)
import "monaco-editor/esm/vs/editor/contrib/bracketMatching/browser/bracketMatching.js";

// Folding: Cmd+Shift+[ / ] (fold/unfold)
import "monaco-editor/esm/vs/editor/contrib/folding/browser/folding.js";

// Indentation: Cmd+] / Cmd+[ (indent/outdent)
import "monaco-editor/esm/vs/editor/contrib/indentation/browser/indentation.js";

// Smart select: Ctrl+Shift+Cmd+Right/Left (expand/shrink selection)
import "monaco-editor/esm/vs/editor/contrib/smartSelect/browser/smartSelect.js";

// Go to line: Ctrl+G
import "monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js";

// Go to symbol: Cmd+Shift+O
import "monaco-editor/esm/vs/editor/standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js";

// Word highlight: highlights other occurrences of selected word
import "monaco-editor/esm/vs/editor/contrib/wordHighlighter/browser/wordHighlighter.js";

// Hover information
import "monaco-editor/esm/vs/editor/contrib/hover/browser/hover.js";

// Word operations: Option+Arrow (jump by word), Option+Backspace (delete word), etc.
import "monaco-editor/esm/vs/editor/contrib/wordOperations/browser/wordOperations.js";

export * as monaco from "monaco-editor/esm/vs/editor/editor.api";
